<script setup lang="ts">
import ScrollSliderCard from "./ScrollSliderCard.vue";
import LevelCard from "./LevelCard.vue";
import type { LevelCardData } from "../model/types";
import { useModalControls } from "../composables/useModalControls";
import { useReversedOrder } from "../composables/useReversedOrder";
import { sendNavigationEvent } from "../lib/sendNavigationEvent";

const props = defineProps<{
  levelsInfo: LevelCardData[]
}>();

const { gtag } = useGtag();

const {
  mountArchivedLevelsModal,
  isShowArchivedLevelsModal,
} = useModalControls();

const { isReversedOrder } = useReversedOrder();
const levelsInfoPrepared = computed(() => isReversedOrder.value ? [...props.levelsInfo].reverse() : props.levelsInfo);
</script>

<template>
  <section class="level-section-wrapper">
    <h2 class="level-section-title">{{ $t("level_section.title") }}</h2>
    <ScrollSliderCard class="override-controls" :items="levelsInfoPrepared">
      <template #default="{ item }">
        <LevelCard
          :cardData="item"
          @navigation-link-clicked="sendNavigationEvent(gtag, $event)"
        />
      </template>
    </ScrollSliderCard>
    <LazyModalsArchivedLevelsModal
      v-if="mountArchivedLevelsModal"
      v-model:is-show-modal="isShowArchivedLevelsModal"
    />
  </section>
</template>

<style scoped lang="scss">
@use "assets/styles/global/variables" as v;

.level-section-wrapper {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.level-section-title, .level-section__button {
  padding-left: 16px;
  padding-right: 16px;

  @media screen and (min-width: v.$tablet) {
    padding-right: v.$content-padding-tablet;
    padding-left: v.$content-padding-tablet;
  }

  @media screen and (min-width: v.$desktop) {
    padding-right: v.$content-padding-desktop;
    padding-left: v.$content-padding-desktop;
  }

  @media screen and (min-width: v.$desktop-1440) {
    padding-right: v.$content-padding-desktop-1440;
    padding-left: v.$content-padding-desktop-1440;
  }
}

.level-section__button {
  display: flex;
  justify-content: center;
}

@media screen and (min-width: v.$desktop) {
  .override-controls:deep(.scroll-slider-card-container) {
    overflow-x: hidden;
  }

  .override-controls:deep(.scroll-slider-control) {
    display: none;
  }
}
</style>